<nav class="pagination-container" aria-label="Pagination">
  <ul class="pagination-list">

    <!-- ← anterior -->
    <li *ngIf="currentPage > 1">
      <a href="#" class="pagination-link" (click)="prevPage(); $event.preventDefault()">←</a>
    </li>

    <!-- Mostrar página 1 solo si no está en visiblePages -->
    <li *ngIf="!getVisiblePages().includes(1)">
      <a href="#"
         class="pagination-link"
         [class.active]="currentPage === 1"
         (click)="onPageClick(1, $event)">
        1
      </a>
    </li>


    <!-- Mostrar ... si hay separación entre página 1 y la siguiente -->
    <li *ngIf="getVisiblePages().length && getVisiblePages()[0] > 2">
      <span class="pagination-ellipsis">…</span>
    </li>

    <!-- Páginas visibles -->
    <li *ngFor="let page of getVisiblePages()">
      <a href="#"
         class="pagination-link"
         [class.active]="page === currentPage"
         (click)="onPageClick(page, $event)">
        {{ page }}
      </a>
    </li>

    <!-- Mostrar ... si hay más después -->
    <li *ngIf="hasMore && currentPage < 3">
      <span class="pagination-ellipsis">…</span>
    </li>

    <!-- → siguiente -->
    <li>
      <a href="#"
         class="pagination-link"
         [class.disabled]="!hasMore"
         (click)="hasMore ? nextPage() : $event.preventDefault(); $event.preventDefault()">
        →
      </a>
    </li>


  </ul>
</nav>
